import React from 'react'
import PasswordPage from '../../UsersPages/UsersProfile/UserPageComponents/PasswordPage'

export default function ResetPassword() {
  return (
    <PasswordPage />
  )
}
